import { PAGES_CONFIG } from "pages/pagesConfig";
import environment from "./baseUrl.json";

type PageConfigKeys = keyof typeof PAGES_CONFIG;

interface ApiEndpoints {
  host: string;
  login: string;
  refreshToken: string;
  verify: string;
  profile: string;
  network: string;
  dashboard: string;
  files: string;
  checkCountriesSlug: string;
  permissions: string;
  visaFeeType: string;
  [key: string]: any;
}

interface ApiResource {
  base: string;
  list: string;
  get: string;
  delete: string;
  getBySlug: string;
  getSingle: string;
  changeStatus: string;
}

const generateApiResources = (path: string): ApiResource =>
  path === "admin"
    ? {
        base: `/${path}`,
        list: `/${path}/list`,
        get: `/${path}/get`,
        delete: `/${path}/delete`,
        getBySlug: `/${path}/getBySlug`,
        getSingle: `/${path}/getSingle`,
        changeStatus: `/${path}/changeStatus`,
      }
    : {
        base: `/admin/${path}`,
        list: `/admin/${path}/list`,
        get: `/admin/${path}/get`,
        delete: `/admin/${path}/delete`,
        getBySlug: `/admin/${path}/getBySlug`,
        getSingle: `/admin/${path}/getSingle`,
        changeStatus: `/admin/${path}/changeStatus`,
      };

const apiEndpoints: ApiEndpoints = {
  host: process.env.REACT_APP_BASE_URL || environment.BASE_URL,
  login: "/auth/login",
  refreshToken: "/auth/refresh",
  verify: "/auth/verify-login",
  network: "/network",
  dashboard: "/admin/dashboard",
  profile: "/admin/users/profile",
  files: "/admin/files",
  servingUnit: "/admin/serving-unit",
  checkCountriesSlug: "/admin/countries/check-slug",
  checkCountryPairSlug: "/admin/country-pairs/check-slug",
  checkVisaTypesSlug: "/admin/visa-types/check-slug",
  permissions: "/admin/permissions",
  visaFeeType: "/admin/visa-fees/visa-fee-type",
};

(Object.keys(PAGES_CONFIG) as Array<PageConfigKeys>).forEach((key) => {
  const config = PAGES_CONFIG[key];
  apiEndpoints[key] = generateApiResources(config.apiAddress);
});

export default apiEndpoints;
